import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-cycle-mixture-row',
	templateUrl: './cycle-mixture-row.component.html',
	styleUrls: ['./cycle-mixture-row.component.scss']
})
export class CycleMixtureRowComponent implements OnInit {
	@Input() public rowData: FormGroup;
	@Input() public displayErrors: boolean;
	@Input() public displayX: boolean = true;
	@Input() public index: number;
	@Output() public removed: EventEmitter<number> = new EventEmitter<number>();
	productsList: string[] = ["קבועה צמודה", "קבועה לא צמודה", "משתנה כל שנתיים לא צמודה", "משתנה כל 5 לא צמודה", "משתנה כל 7 לא צמודה", "משתנה כל שנתיים וחצי צמודה", "משתנה כל 5 צמודה", "משתנה כל 7 צמודה", "משתנה כל 10 צמודה", "פריים"];
	defaultValue = "";


	constructor() { }

	ngOnInit() {
		console.debug("CycleMixtureRowComponent.ngOnInit()", this);
	}

	static buildItem(val: any) {
		return new FormGroup({
			type: new FormControl(val[0] ? val[0].answerValue : ""),
			amount: new FormControl(val[1] ? val[1].answerValue : ""),
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/cycle-mixture-row/cycle-mixture-row.component.ts